(() => {
  function init() {
    const root = document.querySelector('[data-mltf]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const main = document.getElementById('MainContent');
    const catalog = JSON.parse(root.querySelector('[data-mltf-catalog]').textContent).shades.filter(p => p.family === 'liquid');
    const c = JSON.parse(root.querySelector('[data-mltf-text]').textContent);
    const order = ['light','light-medium','medium','medium-tan','sun-tanned','tan','tan-dark','dark'];
    const colours = ['#f1dcc6','#e3c09e','#cc9c75','#b47f59','#ab764d','#966341','#805335','#684430'];
    const $ = s => root.querySelector(s);
    const esc = s => String(s ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
    const norm = s => String(s ?? '').trim().toLowerCase().replace(/\s+/g,' ');
    const key = 'miLiquidTesterProductV1';
    let depth = '', tone = 'all', chosen = [], group, timer, syncing = false, generation = 0;
    const inputs = () => group ? [...group.querySelectorAll('input.tpo-checkbox-button')] : [];
    const shadeFor = input => catalog.find(p => norm(p.name) === norm(input.value));
    const selected = () => inputs().filter(i => i.checked).map(shadeFor).filter(Boolean).map(p => p.id);
    const persist = () => { try { sessionStorage.setItem(key, JSON.stringify(chosen)); } catch (_) {} };
    const matches = p => tone === 'all' || p.under === tone || tone === 'neutral' && p.under.startsWith('neutral-') || tone === 'cool' && p.under === 'neutral-cool' || tone === 'warm' && p.under === 'neutral-warm';
    function render() {
      $('[data-mltf-tonestep]').hidden = !depth;
      $('[data-mltf-resultssection]').hidden = !depth;
      root.querySelectorAll('[data-mltf-depth]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mltfDepth === depth)));
      root.querySelectorAll('[data-mltf-tone]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mltfTone === tone)));
      const found = catalog.filter(p => p.depths.includes(depth) && matches(p));
      $('[data-mltf-status]').textContent = !found.length ? c.empty : found.length === 1 ? c.one : c.many.replace('{{ count }}', found.length);
      $('[data-mltf-results]').innerHTML = found.map(p => {
        const picked = chosen.includes(p.id);
        const available = inputs().some(i => shadeFor(i)?.id === p.id);
        return '<article class="mltf-shade"><img src="'+esc(p.image)+'" alt="'+esc(p.name)+'" width="160" height="115" loading="lazy"><h4>'+esc(p.name)+'</h4><p>'+esc(c.tone[p.under])+'</p><button type="button" data-mltf-pick="'+esc(p.id)+'" aria-pressed="'+picked+'" aria-label="'+esc((picked ? c.selected : c.add)+' '+p.name)+'"'+(!available || syncing || !picked && chosen.length >= 3 ? ' disabled' : '')+'>'+esc(picked ? c.selected+' ✓' : c.add)+'</button></article>';
      }).join('');
      $('[data-mltf-count]').textContent = chosen.length+'/3';
      $('[data-mltf-list]').innerHTML = chosen.map(id => catalog.find(p => p.id === id)).filter(Boolean).map(p => '<li><span>'+esc(p.name)+'</span><button type="button" data-mltf-remove="'+esc(p.id)+'" aria-label="'+esc(c.remove+' '+p.name)+'"'+(syncing ? ' disabled' : '')+'>×</button></li>').join('');
      if (!syncing) $('[data-mltf-progress]').textContent = chosen.length === 3 ? c.ready : chosen.length === 2 ? c.needOne : c.need.replace('{{ count }}', 3-chosen.length);
    }
    function propertyValid() {
      const names = chosen.map(id => catalog.find(p => p.id === id).name).map(norm).sort();
      return [...group.querySelectorAll('input[name^="properties["]')].some(i => {
        const values = i.value.split(',').map(norm).filter(Boolean).sort();
        return names.length === values.length && names.every((name, index) => name === values[index]);
      });
    }
    function apply(focusId = null) {
      const run = ++generation;
      const deadline = Date.now()+6000;
      syncing = true;
      $('[data-mltf-progress]').textContent = c.pending;
      render();
      function step() {
        if (run !== generation || !root.isConnected) return;
        const all = inputs();
        const extra = all.find(i => i.checked && !chosen.includes(shadeFor(i)?.id));
        const missing = all.find(i => !i.checked && chosen.includes(shadeFor(i)?.id));
        if (Date.now() > deadline) {
          syncing = false; chosen = selected().slice(0,3); render();
          $('[data-mltf-progress]').textContent = c.error;
          return;
        }
        if (extra || missing) { ((extra || missing).closest('label') || extra || missing).click(); timer = setTimeout(step,100); return; }
        if (!propertyValid()) {timer = setTimeout(step,100); return;}
        syncing = false; chosen = selected().slice(0,3); persist(); render();
        if (focusId) {
          const target = focusId === 'remove' ? $('[data-mltf-remove]') || $('[data-mltf-depth]') : root.querySelector('[data-mltf-pick="'+focusId+'"]');
          if (target) target.focus({preventScroll:true});
        }
      }
      step();
    }
    function attach() {
      const first = [...main.querySelectorAll('input.tpo-checkbox-button')].find(i => shadeFor(i));
      if (!first) return false;
      group = first.closest('.tpo_option-container');
      if (!group) return false;
      group.before(root);
      root.hidden = false;
      $('[data-mltf-depths]').innerHTML = order.filter(d => catalog.some(p => p.depths.includes(d))).map(d => '<button type="button" data-mltf-depth="'+d+'" aria-pressed="false"><span class="mltf-dot" style="background:'+colours[order.indexOf(d)]+'" aria-hidden="true"></span>'+esc(c.depth[order.indexOf(d)])+'</button>').join('');
      $('[data-mltf-tones]').innerHTML = ['all','cool','neutral','warm'].map(t => '<button type="button" data-mltf-tone="'+t+'" aria-pressed="'+(t==='all')+'">'+esc(c.tone[t])+'</button>').join('');
      const raw = new URLSearchParams(location.search).get('mi_testers');
      if (raw) {
        const names = [...new Set(raw.split(',').map(norm))];
        if (names.length === 3 && names.every(name => catalog.some(p => norm(p.name) === name))) chosen = names.map(name => catalog.find(p => norm(p.name) === name).id);
      } else {
        chosen = selected().slice(0,3);
        if (!chosen.length) {try { const saved = JSON.parse(sessionStorage.getItem(key) || '[]'); if (Array.isArray(saved)) chosen = [...new Set(saved)].filter(id => catalog.some(p => p.id === id)).slice(0,3); } catch (_) {}}
      }
      group.addEventListener('change', e => {
        if (!e.target.matches('input.tpo-checkbox-button') || syncing) return;
        ++generation; clearTimeout(timer); chosen = selected().slice(0,3); persist(); render();
      });
      render();
      if (chosen.length) apply();
      return true;
    }
    root.addEventListener('click', e => {
      const d = e.target.closest('[data-mltf-depth]');
      if (d) { depth = d.dataset.mltfDepth; render(); return; }
      const t = e.target.closest('[data-mltf-tone]');
      if (t) { tone = t.dataset.mltfTone; render(); return; }
      const pick = e.target.closest('[data-mltf-pick]');
      const remove = e.target.closest('[data-mltf-remove]');
      if ((!pick && !remove) || syncing) return;
      const id = pick ? pick.dataset.mltfPick : remove.dataset.mltfRemove;
      if (chosen.includes(id)) chosen = chosen.filter(value => value !== id);
      else if (chosen.length < 3) chosen.push(id);
      else { $('[data-mltf-progress]').textContent = c.limit; return; }
      apply(pick ? id : 'remove');
    });
    if (!attach()) {
      const observer = new MutationObserver(() => { if (attach()) {observer.disconnect();clearTimeout(expiry);} });
      observer.observe(main,{childList:true,subtree:true});
      const expiry = setTimeout(() => observer.disconnect(),20000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();
